import gql from 'graphql-tag';


export const EHRENAMTLICHE_FINDEN_PARTNERS_FRAGMENT = gql`
    fragment ehrenamtlicheFindenPartners on EhrenamtlicheFindenPartnersType {
    partnersTitle
    partnersTextOne
    partnersTextTwo
    id
  }
`;